import React from 'react'
import _ from 'lodash'
import { useTheme } from '@material-ui/styles'

import analysisStatusConstants from 'utils/constants/analysisStatus'

const PanelTitle = ({ text, services }) => {
  const theme = useTheme()

  // only services called
  const newServices = _.pickBy(services, (s) => !_.isEmpty(_.get(s, 'data_id')))

  // TODO: adicionar outros status
  const colorSelect = () => {
    if (_.isEmpty(newServices)) {
      return theme.palette.primary.grayDark
    }
    if (_.some(newServices, { analysis_status: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.reproved })) {
      return theme.palette.primary.red
    }
    if (_.some(newServices, { analysis_status: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.in_attention })) {
      return theme.palette.primary.inAttention
    }
    if (_.every(newServices, { analysis_status: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.approved })) {
      return theme.palette.primary.green
    }

    return theme.palette.primary.grayDark
  }

  return <div style={{ color: colorSelect() }}>{text}</div>
}

export default PanelTitle
